import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss'],
  standalone: false,
})
export class PaymentSuccessComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    let bookingId = +this.route.snapshot.paramMap.get('id');
    window.location.href = `/bookings/${bookingId}`;
  }
}
